import { Component, OnInit, Inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgForm, FormBuilder, FormGroup, FormControl, FormsModule } from '@angular/forms';
import { Location } from '@angular/common';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import Swal from 'sweetalert2';
import { MediaService } from 'src/app/shared/services/mediaservice/media.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { HttpClient } from '@angular/common/http';
import { SettingservicesService } from 'src/app/shared/services/settingservices/settingservices.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

interface Device {
  device_name: string;
  device_id: string;
  isEditing: boolean;
}
@Component({
  selector: 'app-employee-add',
  templateUrl: './employee-add.component.html',
  styleUrls: ['./employee-add.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule,],
  providers: [DatePipe],
})
export class EmployeeAddComponent implements OnInit {
  selectedCardName = 'TEAM_LEAD_CARD';
  toggleValue = false;
  daysWeek: string[] = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  total_leaves = 0;
  formData: FormData = new FormData();
  imagePath: any;
  selectPortalCheckIn = false;
  radioBtn_team_holidays = false;
  viewList_Chkbox_team_holidays = false;
  addNew_Chkbox_team_holidays = false;
  update_Chkbox_team_holidays = false;
  delete_Chkbox_team_holidays = false;
  objectDataJson: any;
  public showSpinner = false;
  checkbox1 = false;
  checkbox2 = false;
  showDiv = false;
  adminhidden = false;
  team_resign = false;
  team_leadteam_resign = false;
  team_lead_holidays = false;
  team_manage = false;
  employee = false;
  team_lead = false;
  admin = false;
  formGroup: any;
  departments: any;
  department: any;
  organizations: any;
  designations: any;
  employeeType: any;
  statuses: any;
  countryList: any;
  fileToUpload: any;
  first_name: any = '';
  apidata: any = {};
  addressdata: any;
  jsondata: any;
  prseinfo: any;
  stringinfo: any;
  uuid: any;
  user_total_working_hours: any;
  roleManagment: any;
  selected: any;
  selectedRoles: any;
  slectedEvaluation: any;
  selectedEvaluationRole: any;
  evaluationRole: any;
  roleResign: any;
  resignRoles: any;
  resignMainRoles: any;
  roleHolidays: any;
  holidaysMainRole: any;
  holidaysSubRoles: any;
  roleMedia: any;
  mediaMainRole: any;
  mediaSubRoles: any;
  leaveManagement: any;
  leaveSubRoles: any;
  attendanceManagement: any;
  eventManagement: any;
  attendanceSubRoles: any;
  attendanceMainRole: any;
  eventSubRoles: any;
  eventMainRole: any;
  stringValue: any;
  address: any;
  admin_checkbox_value = false;
  event_checkbox_value = false;
  teamLead: any;
  leaveManagementMainRole: any;
  roleType: any;
  updatePassword = false;
  user: any;
  value: any;
  attandance_type: any;
  attendanceTpye: any;
  portalCheckInRadioGroup: any;
  leaveCount = 0;
  emp_type: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  joining: any;
  accountManagement: any;
  accountMainRole: any;
  accountSubRoles: any;
  device_name: any;
  device_id: any;
  cards: any;
  toggleValueMultiplePunch = false;
  multiplepush = 'No';
  workfromhome = 'No';
  monStartTime: any;
  monEndTime: any;
  monTotalWorkingHours: any;
  tueStartTime: any;
  tueEndTime: any;
  tueTotalWorkingHours: any;
  wedStartTime: any;
  wedEndTime: any;
  wedTotalWorkingHours: any;
  thuStartTime: any;
  thuEndTime: any;
  thuTotalWorkingHours: any;
  friStartTime: any;
  friEndTime: any;
  friTotalWorkingHours: any;
  satStartTime: any;
  satEndTime: any;
  satTotalWorkingHours: any;
  sunStartTime: any;
  sunEndTime: any;
  sunTotalWorkingHours: any;
  selectedRole: any;
  disable_user_excluded_attendance = false;
  attendance_user_id: number | null = null;
  original_attendance_user_id: number | null = null;
  // attendance_user_id: number | null = null;
  // team evaluation
  evaluation = {
    evaluationEnabled: false,
    RadioBtn_TeamEvaluation: 'null',
    team_evaluation_viewList: false,
    team_evaluation_addNew: false,
    team_evaluation_update: false,
    team_evaluation_sendEmail: false,
  };

  // team_management
  team_management = {
    radio_btn_management: 'null',
    team_managementEnabled: false,
    viewPayRoll_chkbox_team_management: false,
    updateCheckIn_chkbox_team_management: false,
    addNewUser_chkbox_team_management: false,
    createPayRoll_chkbox_team_management: false,
    deleteUser_chkbox_team_management: false,
    updateUser_chkbox_team_management: false,
    montlySalary_chkbox_team_management: false,
    loanView_chkbox_team_management: false,
    loanAccept_chkbox_team_management: false,
    loanReject_chkbox_team_management: false,
  };

  // team resign
  resign = {
    resignEnabled: false,
    radioBtn_resign: 'null',
    viewList_chekboc_team_resign: false,
    acceptResign_chekboc_team_resign: false,
    rejectResign_chekboc_team_resign: false,
  };

  // holidays
  holidays = {
    holidaysEnabled: false,
    radioBtn_holidays: 'null',
    viewList_Chkbox_team_holidays: false,
    addNew_Chkbox_team_holidays: false,
    update_Chkbox_team_holidays: false,
    delete_Chkbox_team_holidays: false,
  };

  // upload media
  upload_media = {
    upload_mediaEnabled: false,
    radioBtn_upload_media: 'null',
    viewList_chekBox_upload_media: false,
    uploadMedia_chekBox_upload_media: false,
    deleteMedia_chekBox_upload_media: false,
  };
  // leave management
  leave_management = {
    leave_managementEnabled: false,
    radioBtn_leave_management: 'null',
    viewListAllLeaves_chekBox_leave_management: false,
    acceptLeaves_chekBox_leave_management: false,
    rejectLeaves_chekBox_leave_management: false,
    updateLeaves_chekBox_leave_management: false,
  };

  // attendance_managment
  attendance_managment = {
    attendace_managementEnable: false,
    radiobtn_attendace_management: 'null',
    viewAttendance_chkBox_attentance_management: false,
    edit_chkBox_attentance_management: false,
    sheet_chkBox_attentance_management: false,
    report_chkBox_attentance_management: false,
    delete_chkBox_attentance_management: false,
  };
  // event Managment
  event_managment = {
    event_managementEnable: false,
    radiobtn_event_management: 'null',
    view_chkBox_event_management: false,
    add_chkBox_event_management: false,
    edit_chkBox_event_management: false,
    delete_chkBox_event_management: false,
  };
  // account managment
  account_managment = {
    account_managementEnable: false,
    radiobtn_account_management: 'null',
    view_chkBox_account_management: false,
    add_chkBox_account_management: false,
    edit_chkBox_account_management: false,
    delete_chkBox_account_management: false,
    export_chkBox_account_management: false,
    add_supperadmin_account_management: false,
  };
  usershittime: any;
  shifttimedata: any;
  user_shiftStarttime: any;
  user_shiftendtime: any;
  employee_status: any;
  user_total_leaves: any;
  reniewLeaves: any;
  hidenbutton = false;
  permanentDate: any;
  office_roles: any;
  office_roles_array: any;
  current_user_id: any;
  user_Roles: any;
  salaryType = 'monthly';

 address1Value: any;
  filteredSuggestions: any;




  devices: Device[] = []; // store all devices
  showForm = true; // show form by default if no devices
  newDevice: Device = { device_name: '', device_id: '', isEditing: false };
  attendance_id: any;
  address_id: any;
  address2Value: any;
  city2: any;
  state2: any;
  postal_cide2: any;
  country2: any;
  address_lat: any;
  address_lng: any;
  dropdownOpenIndex: number | null = null;


  onEmployeeChange(): void {
    if (this.employee) {
      this.team_lead = false;
      this.admin = false;
    }
  }

  onSelectTL(v: boolean): void {
    this.team_lead = v;
  }

  onSelectAdmin(v: boolean): void {
    this.admin_checkbox_value = v;
  }

  roleCheck(): void { }



  // calculation of working hours
  calculateWorkingHours(day: string) {
    if (this.dayData[day].startTime && this.dayData[day].endTime) {
      const startTime = new Date(`1970-01-01T${this.dayData[day].startTime}`);
      const endTime = new Date(`1970-01-01T${this.dayData[day].endTime}`);

      // If end time is before start time, assume it's the next day
      if (endTime <= startTime) {
        endTime.setDate(endTime.getDate() + 1);
      }

      const diff = (endTime.getTime() - startTime.getTime()) / (1000 * 60 * 60); // Difference in hours
      this.dayData[day].totalWorkingHours = diff.toFixed(2); // Set total working hours with 2 decimal places
    } else {
      this.dayData[day].totalWorkingHours = null; // Clear total working hours if times are not set
    }
  }

  // name check
  restrictInputToAlphabets(event: Event) {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;
    const onlyAlphabets = inputValue.replace(/[^a-zA-Z ]/g, '');

    if (onlyAlphabets !== inputValue) {
      input.value = onlyAlphabets;
      input.dispatchEvent(new Event('input')); // Update ngModel value
    }
  }

  // last name
  restrictlastname(event: Event) {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;
    const onlyAlphabets = inputValue.replace(/[^a-zA-Z0-9@!#$%^&*()]/g, '');
    if (onlyAlphabets !== inputValue) {
      input.value = onlyAlphabets;
      input.dispatchEvent(new Event('input')); // Update ngModel value
    }
  }

  // password checking
  passwordsMatch = true;
  password = '';
  confirm_password = '';
  checkPasswordsMatch() {
    this.passwordsMatch = this.password === this.confirm_password;
  }
  // image

  selectedFileName: string | null = null;
  selectedImage: string | ArrayBuffer | null = null; // This will store the selected image data
  profileImageInvalid = false;
  onFileChange(event: any) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileToUpload = event.target.files[0] as File;
      this.formData.append('file', fileToUpload, fileToUpload.name);
      this.uploadProfileImage();
      const fileSizeKB = selectedFile.size / 1024;
      if (fileSizeKB <= 1025) {
        this.selectedFileName = selectedFile.name;
        this.profileImageInvalid = false;

        // Read the selected image and convert it to a data URL
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.selectedImage = e.target.result; // Set the selected image data
        };
        reader.readAsDataURL(selectedFile);
      } else {
        this.selectedFileName = null;
        this.selectedImage = null;
        this.profileImageInvalid = true;
        event.target.value = ''; // Clear the input value
      }
    }
  }

  constructor(
    private route: ActivatedRoute,
    private mediaService: MediaService,
    public _location: Location,
    private http: HttpClient,
    public router: Router,
    @Inject(AddService) private addService: AddService,
    public datepipe: DatePipe,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private settings: SettingservicesService,

  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

    const user_role = JSON.parse(this.user.user_role.user_roles);
    if (user_role.role_type == 'Employee') {
      this.router.navigate(['/dashboard-1']);
    }

  }

  ngOnInit(): void {
    this.getcard();
    this.getData();
    this.getAttendaceID();
    this.route.params.subscribe((params) => {
      this.uuid = params['uuid'];
      if (this.uuid !== undefined) {
        this.showUserData(this.uuid);
      }
    });
    // this.calculateInitialLeaveCount();
    this.sharedmode.data$.subscribe((mode) => {
      this.selectedMode = mode;
    });
    this.getleavesmodifidate();

  }


  getAttendaceID() {
    this.addService.getAttendanceId().then((value) => {
      this.attendance_id = value.data
      if (this.attendance_id && !this.uuid) {
        this.attendance_user_id = this.attendance_id + 1;
      }

    })

  }



  toggleMode(mode: string) {
    this.datamode;
    this.sharedmode.setMode(mode);
  }
  restrictInputToAccounts(event: Event) {
    const input = event.target as HTMLInputElement;
    let inputValue = input.value;
    const modifiedValue = inputValue
      .replace(/[^0-9-]/g, '')
      .replace(/-{2,}/g, '-');
    const firstHyphenIndex = modifiedValue.indexOf('-');
    const lastHyphenIndex = modifiedValue.lastIndexOf('-');

    if (firstHyphenIndex !== lastHyphenIndex) {
      const hyphenRemovedValue =
        modifiedValue.substring(0, lastHyphenIndex) +
        modifiedValue.substring(lastHyphenIndex + 1);
      inputValue = hyphenRemovedValue;
    } else {
      inputValue = modifiedValue;
    }

    if (inputValue !== input.value) {
      input.value = inputValue;
      input.dispatchEvent(new Event('input'));
    }
  }
  backward() {
    this.router.navigate(['/team-management']);
  }

  getData() {
    this.showSpinner = true;
    this.addService.getStaticData().then((value) => {
      this.showSpinner = false;
      this.departments = value.data.departments;
      this.organizations = value.data.organizationData;
      this.designations = value.data.designationData;
      this.employeeType = value.data.employeeTypes;
      this.statuses = value.data.statuses;
      this.office_roles = value.data.officeRolesId
      this.office_roles_array = Object.entries(this.office_roles).map(([id, role_names]) => {
        return { id: Number(id), role_names };
      });
      this.countryList = value.data.country;
      this.showUserRole();
    });
  }


  showUserRole() {
    this.showSpinner = true;
    this.settings.getUSerRole().then((value) => {
      if (value.success == true) {
        this.user_Roles = value.data
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }

    })
    this.showSpinner = false;
  }

  showTeam(department: any) {
    this.showSpinner = true;
    this.addService.teamLead(department).then((value) => {
      this.showSpinner = false;
      this.teamLead = value.data;
    });
  }

  getLeaveCount(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const emp_type = selectElement.value;

    if (emp_type !== 'Permanent') {
      this.hidenbutton = false;
      if (emp_type === 'Interne' || emp_type === 'Probabtion') {
        this.total_leaves = 2;
      } else {
        this.total_leaves = 0;
      }
      return;
    } else {
      this.hidenbutton = true;
      this.calculateLeaves();
    }
  }

  onPermanentDateChange(): void {
    this.calculateLeaves();
  }

  calculateLeaves(): void {
    const permanent_Day = new Date(this.permanentDate);
    if (isNaN(permanent_Day.getTime())) {
      return;
    }

    const lastdayofYear = new Date(this.reniewLeaves);
    lastdayofYear.setFullYear(lastdayofYear.getFullYear() + 1);

    const days = Math.ceil(
      (lastdayofYear.getTime() - permanent_Day.getTime()) / (1000 * 60 * 60 * 24)
    );

    // this.total_leaves = parseFloat(((days * (21 / 365))).toFixed(2));

    this.total_leaves = Math.round(((days * (21 / 365))) * 2) / 2;

  }


  getleavesmodifidate() {
    this.showSpinner = true;
    this.addService.getmodifidate().then((value) => {
      this.showSpinner = false;
      this.reniewLeaves = value.data.leave_modify_date;

    });
  }

  selectedEmployeeType = '';
  // calculateInitialLeaveCount() { }
  // show user data
  showUserData(uuid: string) {
    this.showSpinner = true;
    this.addService.updateUser(uuid).then((value) => {
      this.apidata = value?.data;
      if (this.apidata && this.apidata.usershittime) {
        const allDaysOff = this.apidata.usershittime.every((dayData: { off_day: string }) => dayData.off_day === "1");
        this.disable_user_excluded_attendance = allDaysOff;
      }
      if (this.apidata != null) {

        this.original_attendance_user_id = this.apidata.attendance_user_id ?? null;
        if (this.disable_user_excluded_attendance && this.apidata.attendance_user_id == '-8888') {
          this.attendance_user_id = null;
          this.original_attendance_user_id = null;
        } else {
          this.attendance_user_id = this.apidata.attendance_user_id ?? null;
          this.disable_user_excluded_attendance = false;
        }

      }

      if (this.apidata?.salary_type) {
        this.salaryType = this.apidata.salary_type;  // pre-select radio
      }
      this.selectedRole = this.apidata?.user_role?.id;
      this.total_leaves = this.apidata?.total_leaves;
      this.current_user_id = value?.data?.id
      this.user_shiftStarttime = this.apidata?.shift_start_time;
      this.user_shiftendtime = this.apidata?.shift_end_time;
      this.user_total_working_hours = this.apidata?.total_working_hours;
      this.usershittime = value?.data?.usershittime;
      this.getDataFromApi();
      this.selectedCardName = this.apidata.card_name;

      const device_info = this.apidata?.device_id;
      const device_data = JSON.parse(device_info) ?? null;
      this.devices = device_data;

      this.multiplepush = this.apidata.multiple_punch;

      if (this.multiplepush == 'Yes') {
        this.toggleValueMultiplePunch = true;
      } else {
        this.toggleValueMultiplePunch = false;
      }

      this.selectedEmployeeType = this.apidata.employee_type;
      this.joining = this.apidata.joining_date;
      if (this.apidata != null && this.apidata.attandance_type != null) {
        this.showDiv = true;
      } else {
        this.showDiv = false;
      }
      this.showTeam(this.apidata.department);
      this.imagePath = this.apidata.profile_image;
      if (this.apidata?.profile_image) {
        // If backend gives just filename, prepend your API base URL
        this.selectedImage = this.apidata.profile_image;
      } else {
        this.selectedImage = null;
      }
      this.addressdata = value?.data?.address;
      this.jsondata = JSON.parse(value?.data?.user_role?.user_roles);
      this.stringinfo = this.jsondata ?? null;
      this.address = value.data.address;
      this.user_total_leaves = value.data?.total_leaves
      this.address_lat =  this.addressdata?.address_lat
      this.address_lng =  this.addressdata?.address_lng
      // team evaluation Section
      this.evaluationRole = this.jsondata?.team_evaluation;
      // team and all selection
      this.slectedEvaluation = this.evaluationRole?.data?.type;
      this.apidata.attandance_type;
      //All Role
      if (this.slectedEvaluation != null && this.slectedEvaluation === 'all') {
        this.evaluation.RadioBtn_TeamEvaluation =
          'all_RadioBtn_team_evaluation';
      } else if (
        this.slectedEvaluation != null &&
        this.slectedEvaluation === 'team'
      ) {
        this.evaluation.RadioBtn_TeamEvaluation =
          'team_RadioBtn_team_evaluation';
      } else {
        this.evaluation.RadioBtn_TeamEvaluation = 'null';
      }
      // subroles
      this.selectedEvaluationRole = this.evaluationRole?.data?.values;
      (this.evaluation.evaluationEnabled =
        this.evaluationRole?.evaluation ?? false),
        (this.evaluation.team_evaluation_viewList =
          this.selectedEvaluationRole?.view ?? false),
        (this.evaluation.team_evaluation_addNew =
          this.selectedEvaluationRole?.add ?? false),
        (this.evaluation.team_evaluation_update =
          this.selectedEvaluationRole?.update ?? false),
        (this.evaluation.team_evaluation_sendEmail =
          this.selectedEvaluationRole?.sendmail ?? false),
        // team Management Section
        (this.roleManagment = this.jsondata?.team_managment?.team_management);
      // team and all selection
      this.selected = this.jsondata?.team_managment?.data?.type;
      //attendance type
      if (this.selected != null && this.selected === 'all') {
        this.team_management.radio_btn_management =
          'all_radioBtn_team_management';
      } else if (this.selected != null && this.selected === 'team') {
        this.team_management.radio_btn_management = 'radio_btn_team_management';
      } else {
        this.team_management.radio_btn_management = 'null';
      }

      //All Role
      if (this.selected != null && this.selected === 'all') {
        this.team_management.radio_btn_management =
          'all_radioBtn_team_management';
      } else if (this.selected != null && this.selected === 'team') {
        this.team_management.radio_btn_management = 'radio_btn_team_management';
      } else {
        this.team_management.radio_btn_management = 'null';
      }
      // team_management subroles
      this.selectedRoles = this.jsondata?.team_managment?.data?.values;
      this.team_management.team_managementEnabled = this.roleManagment || false;
      this.team_management.viewPayRoll_chkbox_team_management =
        this.selectedRoles?.view || false;
      this.team_management.updateCheckIn_chkbox_team_management =
        this.selectedRoles?.update || false;
      this.team_management.addNewUser_chkbox_team_management =
        this.selectedRoles?.add || false;
      this.team_management.createPayRoll_chkbox_team_management =
        this.selectedRoles?.create || false;
      this.team_management.deleteUser_chkbox_team_management =
        this.selectedRoles?.delete || false;
      this.team_management.updateUser_chkbox_team_management =
        this.selectedRoles?.updateUser || false;
      this.team_management.montlySalary_chkbox_team_management =
        this.selectedRoles?.monthly_salary || false;
      this.team_management.loanView_chkbox_team_management =
        this.selectedRoles?.loanView || false;
      this.team_management.loanAccept_chkbox_team_management =
        this.selectedRoles?.loanAccept || false;
      this.team_management.loanReject_chkbox_team_management =
        this.selectedRoles?.loanReject || false;

      // Resign Data
      // resign main role
      this.roleResign = this.jsondata?.resign_data?.resign;
      this.resign.resignEnabled = this.roleResign || false;
      // resign data type team or all
      this.resignRoles = this.jsondata?.resign_data?.data?.type;
      //All Role
      if (this.resignRoles != null && this.resignRoles === 'all') {
        this.resign.radioBtn_resign = 'all_radioBtn_team_resign';
      } else if (this.resignRoles != null && this.resignRoles === 'team') {
        this.resign.radioBtn_resign = 'team_radioBtn_team_resign';
      } else {
        this.resign.radioBtn_resign = 'null';
      }
      // All Sub Roles
      this.resignMainRoles = this.jsondata?.resign_data?.data?.values;
      this.resign.viewList_chekboc_team_resign =
        this.resignMainRoles?.view || false;
      this.resign.acceptResign_chekboc_team_resign =
        this.resignMainRoles?.accept || false;
      this.resign.rejectResign_chekboc_team_resign =
        this.resignMainRoles?.reject || false;

      // holidays data
      // holidays main role
      this.roleHolidays = this.jsondata?.holdays_data?.holidays;
      this.holidays.holidaysEnabled = this.roleHolidays || false;
      // holidays data type team or all
      this.holidaysMainRole = this.jsondata?.holdays_data?.data?.type;
      //All Role
      if (this.holidaysMainRole != null && this.holidaysMainRole === 'all') {
        this.holidays.radioBtn_holidays = 'all_radioBtn_team_holidays';
      } else if (
        this.holidaysMainRole != null &&
        this.holidaysMainRole === 'team'
      ) {
        this.holidays.radioBtn_holidays = 'team_radioBtn_team_holidays';
      } else {
        this.holidays.radioBtn_holidays = 'null';
      }

      // All Sub Roles
      this.holidaysSubRoles = this.jsondata?.holdays_data?.data?.values;
      this.holidays.viewList_Chkbox_team_holidays =
        this.holidaysSubRoles?.view || false;
      this.holidays.addNew_Chkbox_team_holidays =
        this.holidaysSubRoles?.add || false;
      this.holidays.update_Chkbox_team_holidays =
        this.holidaysSubRoles?.update || false;
      this.holidays.delete_Chkbox_team_holidays =
        this.holidaysSubRoles?.delete || false;

      // upload media data
      // upload media main role
      this.roleMedia = this.jsondata?.upload_data?.upload_media;
      this.upload_media.upload_mediaEnabled = this.roleMedia || false;
      // holidays data type team or all
      this.mediaMainRole = this.jsondata?.upload_data?.data?.type;
      //All Role
      if (this.mediaMainRole != null && this.mediaMainRole === 'all') {
        this.upload_media.radioBtn_upload_media = 'all_radioBtn_upload_media';
      } else if (this.mediaMainRole != null && this.mediaMainRole === 'team') {
        this.upload_media.radioBtn_upload_media = 'team_radioBtn_upload_media';
      } else {
        this.upload_media.radioBtn_upload_media = 'null';
      }

      // All Sub Roles
      this.mediaSubRoles = this.jsondata?.upload_data?.data?.values;
      this.upload_media.viewList_chekBox_upload_media =
        this.mediaSubRoles?.view || false;
      this.upload_media.uploadMedia_chekBox_upload_media =
        this.mediaSubRoles?.accept || false;
      this.upload_media.deleteMedia_chekBox_upload_media =
        this.mediaSubRoles?.reject || false;
      // leave management data
      // leave management data main role
      this.leaveManagement = this.jsondata?.leave_data?.leave_management;
      this.leave_management.leave_managementEnabled =
        this.leaveManagement || false;
      //Main Role for team and all
      this.leaveManagementMainRole = this.jsondata?.leave_data?.data?.type;
      //All Role
      if (
        this.leaveManagementMainRole != null &&
        this.leaveManagementMainRole === 'all'
      ) {
        this.leave_management.radioBtn_leave_management =
          'all_radioBtn_leave_management';
      } else if (
        this.leaveManagementMainRole != null &&
        this.leaveManagementMainRole === 'team'
      ) {
        this.leave_management.radioBtn_leave_management =
          'team_radioBtn_leave_management';
      } else {
        this.leave_management.radioBtn_leave_management = 'null';
      }
      // All Sub Roles
      this.leaveSubRoles = this.jsondata?.leave_data?.data?.values;
      this.leave_management.viewListAllLeaves_chekBox_leave_management =
        this.leaveSubRoles?.view_leave || false;
      this.leave_management.acceptLeaves_chekBox_leave_management =
        this.leaveSubRoles?.accept || false;
      this.leave_management.rejectLeaves_chekBox_leave_management =
        this.leaveSubRoles?.reject || false;
      this.leave_management.updateLeaves_chekBox_leave_management =
        this.leaveSubRoles?.update || false;

      // attendance management data
      // attendance management data main role
      this.attendanceManagement =
        this.jsondata?.attendance_data?.attentance_management;
      this.attendance_managment.attendace_managementEnable =
        this.attendanceManagement || false;
      // Team or All Role
      this.attendanceMainRole = this.jsondata?.attendance_data?.data?.type;
      //All Role
      if (
        this.attendanceMainRole != null &&
        this.attendanceMainRole === 'all'
      ) {
        this.attendance_managment.radiobtn_attendace_management =
          'attendace_managementEnable_all';
      } else if (
        this.attendanceMainRole != null &&
        this.attendanceMainRole === 'team'
      ) {
        this.attendance_managment.radiobtn_attendace_management =
          'attendace_managementEnable_team';
      } else {
        this.attendance_managment.radiobtn_attendace_management = 'null';
      }

      this.admin_checkbox_value = false;
      this.team_lead = false;
      this.admin = false;
      if (this.jsondata.role_type === 'Team_Lead') {
        this.admin_checkbox_value = true;
        this.team_lead = true;
      } else if (this.jsondata.role_type === 'Admin') {
        this.admin_checkbox_value = true;
        this.admin = true;
      } else if (this.jsondata.role_type === 'Admin_AND_Team_Lead') {
        this.admin_checkbox_value = true;
        this.admin = true;
        this.team_lead = true;
      }
      // All Sub Roles
      this.attendanceSubRoles = this.jsondata?.attendance_data?.data?.values;
      this.attendance_managment.viewAttendance_chkBox_attentance_management =
        this.attendanceSubRoles?.view_attedance || false;
      this.attendance_managment.edit_chkBox_attentance_management =
        this.attendanceSubRoles?.edit || false;
      this.attendance_managment.sheet_chkBox_attentance_management =
        this.attendanceSubRoles?.sheet || false;
      this.attendance_managment.report_chkBox_attentance_management =
        this.attendanceSubRoles?.report || false;
      this.attendance_managment.delete_chkBox_attentance_management =
        this.attendanceSubRoles?.delete || false;
      this.attendanceTpye = value?.data?.attandance_type;

      // event Management
      this.eventManagement = this.jsondata?.event_data?.event_managment;
      this.event_managment.event_managementEnable =
        this.eventManagement || false;
      // Team or All Role
      this.eventMainRole = this.jsondata?.event_data?.data?.type;
      //All Role
      if (this.eventMainRole != null && this.eventMainRole === 'all') {
        this.event_managment.radiobtn_event_management =
          'event_managementEnable_all';
      } else if (this.eventMainRole != null && this.eventMainRole === 'team') {
        this.event_managment.radiobtn_event_management =
          'event_managementEnable_team';
      } else {
        this.event_managment.radiobtn_event_management = 'null';
      }

      this.admin_checkbox_value = false;
      this.team_lead = false;
      this.admin = false;
      if (this.jsondata.role_type === 'Team_Lead') {
        this.admin_checkbox_value = true;
        this.team_lead = true;
      } else if (this.jsondata.role_type === 'Admin') {
        this.admin_checkbox_value = true;
        this.admin = true;
      } else if (this.jsondata.role_type === 'Admin_AND_Team_Lead') {
        this.admin_checkbox_value = true;
        this.admin = true;
        this.team_lead = true;
      }
      // All Sub Roles
      this.eventSubRoles = this.jsondata?.event_data?.data?.values;
      this.event_managment.view_chkBox_event_management =
        this.eventSubRoles?.view || false;
      this.event_managment.add_chkBox_event_management =
        this.eventSubRoles?.add || false;
      this.event_managment.edit_chkBox_event_management =
        this.eventSubRoles?.edit || false;
      this.event_managment.delete_chkBox_event_management =
        this.eventSubRoles?.delete || false;

      // account managment
      // event Management
      this.accountManagement = this.jsondata?.account_data?.account_managment;
      this.account_managment.account_managementEnable =
        this.accountManagement || false;
      // Team or All Role
      this.accountMainRole = this.jsondata?.account_data?.data?.type;
      //All Role
      if (this.accountMainRole != null && this.accountMainRole === 'all') {
        this.account_managment.radiobtn_account_management =
          'account_managementEnable_all';
      } else if (
        this.accountMainRole != null &&
        this.accountMainRole === 'team'
      ) {
        this.account_managment.radiobtn_account_management =
          'account_managementEnable_team';
      } else {
        this.account_managment.radiobtn_account_management = 'null';
      }

      this.admin_checkbox_value = false;
      this.team_lead = false;
      this.admin = false;
      if (this.jsondata.role_type === 'Team_Lead') {
        this.admin_checkbox_value = true;
        this.team_lead = true;
      } else if (this.jsondata.role_type === 'Admin') {
        this.admin_checkbox_value = true;
        this.admin = true;
      } else if (this.jsondata.role_type === 'Admin_AND_Team_Lead') {
        this.admin_checkbox_value = true;
        this.admin = true;
        this.team_lead = true;
      }
      // All Sub Roles
      this.accountSubRoles = this.jsondata?.account_data?.data?.values;
      this.account_managment.add_supperadmin_account_management =
        this.accountSubRoles?.admin || false;
      this.account_managment.view_chkBox_account_management =
        this.accountSubRoles?.view || false;
      this.account_managment.add_chkBox_account_management =
        this.accountSubRoles?.add || false;
      this.account_managment.edit_chkBox_account_management =
        this.accountSubRoles?.edit || false;
      this.account_managment.delete_chkBox_account_management =
        this.accountSubRoles?.delete || false;
      this.account_managment.export_chkBox_account_management =
        this.accountSubRoles?.export || false;
    });
  }

  // addNewDevice() {
  //   if (!Array.isArray(this.device_id)) {
  //     this.device_id = [];
  //   }
  //   this.device_id.push({
  //     device_name: '',
  //     device_id: '',
  //     isEditing: true,
  //   });
  // }

  // Method to handle editing or saving a device
  editOrSaveDevice(device: any) {
    if (device.isEditing) {
      // Save the device
      device.isEditing = false;
      // Optionally, you can send the updated device to a backend server here
    } else {
      // Edit the device
      device.isEditing = true;
    }
  }

  // // Method to delete a device
  // deleteDevice(index: number) {
  //   this.device_id.splice(index, 1);
  // }

  onToggleChange() {
    if (this.disable_user_excluded_attendance) {
      this.attendance_user_id = null;
      this.offDayStatus['mon'] = true;
      this.offDayStatus['tue'] = true;
      this.offDayStatus['wed'] = true;
      this.offDayStatus['thu'] = true;
      this.offDayStatus['fri'] = true;
      this.offDayStatus['sat'] = true;
      this.offDayStatus['sun'] = true;


    } else {
      // optionally reset or restore the original value here
      this.attendance_user_id = this.original_attendance_user_id; // or keep previous apidata.attendance_user_id if needed
      this.offDayStatus['mon'] = false;
      this.offDayStatus['tue'] = false;
      this.offDayStatus['wed'] = false;
      this.offDayStatus['thu'] = false;
      this.offDayStatus['fri'] = false;
      this.offDayStatus['sat'] = false;
      this.offDayStatus['sun'] = false;
      this.getAttendaceID();

    }
  }
  shouldShowExcludedAttendance(): boolean {
    return !this.disable_user_excluded_attendance;
  }
  //form data
  onSubmit(f: NgForm) {
    const v = f.value;

    // 1. Profile Image Validation
    if (!this.selectedImage && (v.profile_image == null || v.profile_image == undefined)) {
      this.showValidationError('Profile Image is required');
      return;
    }

    // 2. Personal Details Validation
    if (!this.disable_user_excluded_attendance && (v.attendance_user_id == null || v.attendance_user_id === '')) {
      this.showValidationError('Attendance ID is required');
      return;
    }
    if (!v.gender || v.gender === 'null') {
      this.showValidationError('Gender is required');
      return;
    }
    if (!v.first_name || v.first_name.trim() === '') {
      this.showValidationError('First Name is required');
      return;
    }
    if (!v.last_name || v.last_name.trim() === '') {
      this.showValidationError('Last Name is required');
      return;
    }

    // Password Validation (only for new users)
    if (!this.uuid) {
      if (!v.password || v.password.trim() === '') {
        this.showValidationError('Password is required');
        return;
      }
      if (!v.confirm_password || v.confirm_password.trim() === '') {
        this.showValidationError('Confirm Password is required');
        return;
      }
      if (v.password !== v.confirm_password) {
        this.showValidationError('Passwords do not match');
        return;
      }
    }

    if (!v.email || v.email.trim() === '') {
      this.showValidationError('Email is required');
      return;
    }
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailPattern.test(v.email)) {
      this.showValidationError('Please enter a valid Email Address');
      return;
    }

    if (!v.phone_number) {
      this.showValidationError('Phone Number is required');
      return;
    }
    if (!v.cnic || v.cnic.trim() === '') {
      this.showValidationError('CNIC is required');
      return;
    }
    const cnicPattern = /^[0-9]{5}-[0-9]{7}-[0-9]{1}$/;
    if (!cnicPattern.test(v.cnic)) {
      this.showValidationError('CNIC must follow 00000-0000000-0 format');
      return;
    }
    if (!v.dob) {
      this.showValidationError('Date of Birth is required');
      return;
    }
    if (!this.selectedRole) {
      this.showValidationError('User Role is required');
      return;
    }
    if (!v.about || v.about.trim() === '') {
      this.showValidationError('About field is required');
      return;
    }

    // 3. Address Information Validation
    if (!v.address1 || v.address1.trim() === '') {
      this.showValidationError('Address 1 is required');
      return;
    }
    // if (!v.address2 || v.address2.trim() === '') {
    //   this.showValidationError('Address 2 is required');
    //   return;
    // }
    if (!v.city || v.city.trim() === '') {
      this.showValidationError('City is required');
      return;
    }
    if (!v.state || v.state.trim() === '') {
      this.showValidationError('State is required');
      return;
    }
    if (!v.postal_code) {
      this.showValidationError('Postal Code is required');
      return;
    }
    if (!v.country || v.country === 'null') {
      this.showValidationError('Country is required');
      return;
    }

    // 4. Employment Details Validation
    if (!v.organizationid || v.organizationid === 'null') {
      this.showValidationError('Organization is required');
      return;
    }
    if (!v.designation || v.designation === 'null') {
      this.showValidationError('Designation is required');
      return;
    }
    if (!v.department || v.department === 'null') {
      this.showValidationError('Department is required');
      return;
    }
    if (!v.sub_department || v.sub_department.trim() === '') {
      this.showValidationError('Sub-department is required');
      return;
    }
    if (!v.employee_type || v.employee_type === 'null') {
      this.showValidationError('Job Type is required');
      return;
    }
    if (this.hidenbutton && !this.permanentDate) {
      this.showValidationError('Permanent Date is required for Permanent Job Type');
      return;
    }
    if (!v.joining_date) {
      this.showValidationError('Joining Date is required');
      return;
    }
    if (!v.employee_role || v.employee_role === 'null') {
      this.showValidationError('Job Position is required');
      return;
    }
    if (!v.employee_status || v.employee_status === 'null') {
      this.showValidationError('Employee Status is required');
      return;
    }

    // 5. Salary Details Validation
    // if (!v.salary || v.salary.toString().trim() === '') {
    //   this.showValidationError(this.salaryType === 'monthly' ? 'Monthly Salary is required' : 'Hourly Rate is required');
    //   return;
    // }
    // if (this.salaryType === 'monthly' && (v.tax == null || v.tax === '')) {
    //   this.showValidationError('Salary Tax is required');
    //   return;
    // }
    // if (!v.ac_number || v.ac_number.trim() === '') {
    //   this.showValidationError('Bank Account number is required');
    //   return;
    // }

    // 6. Devices Info Validation
    // if (!this.devices || this.devices.length === 0) {
    //   if (!this.newDevice.device_name || this.newDevice.device_name.trim() === '') {
    //     this.showValidationError('At least one Device Name is required');
    //     return;
    //   }
    //   if (!this.newDevice.device_id || this.newDevice.device_id.trim() === '') {
    //     this.showValidationError('At least one Device ID is required');
    //     return;
    //   }
    // }

    // 7. Shift Details Validation
    if (!this.disable_user_excluded_attendance) {
      const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
      for (const day of days) {
        if (!this.offDayStatus[day]) {
          if (!this.dayData[day].startTime) {
            this.showValidationError(`Shift Start Time is required for ${day.toUpperCase()}`);
            return;
          }
          if (!this.dayData[day].endTime) {
            this.showValidationError(`Shift End Time is required for ${day.toUpperCase()}`);
            return;
          }
          if (!this.dayData[day].totalWorkingHours || this.dayData[day].totalWorkingHours === '0') {
            this.showValidationError(`Working Hours must be calculated for ${day.toUpperCase()}`);
            return;
          }
        }
      }
    }

    const shiftDetails = [
      {
        day: this.daysWeek[0],
        shiftStartTime: this.dayData.mon.startTime || null,
        shiftEndTime: this.dayData.mon.endTime || null,
        totalWorkingHour: this.dayData.mon.totalWorkingHours || null,
        WFH: this.toggleValues['mon'],
        offDay: this.offDayStatus['mon'],
      },
      {
        day: this.daysWeek[1],
        shiftStartTime: this.dayData.tue.startTime || null,
        shiftEndTime: this.dayData.tue.endTime || null,
        totalWorkingHour: this.dayData.tue.totalWorkingHours || null,
        WFH: this.toggleValues['tue'],
        offDay: this.offDayStatus['tue'],
      },
      {
        day: this.daysWeek[2],
        shiftStartTime: this.dayData.wed.startTime || null,
        shiftEndTime: this.dayData.wed.endTime || null,
        totalWorkingHour: this.dayData.wed.totalWorkingHours || null,
        WFH: this.toggleValues['wed'],
        offDay: this.offDayStatus['wed'],
      },
      {
        day: this.daysWeek[3],
        shiftStartTime: this.dayData.thu.startTime || null,
        shiftEndTime: this.dayData.thu.endTime || null,
        totalWorkingHour: this.dayData.thu.totalWorkingHours || null,
        WFH: this.toggleValues['thu'],
        offDay: this.offDayStatus['thu'],
      },
      {
        day: this.daysWeek[4],
        shiftStartTime: this.dayData.fri.startTime || null,
        shiftEndTime: this.dayData.fri.endTime || null,
        totalWorkingHour: this.dayData.fri.totalWorkingHours || null,
        WFH: this.toggleValues['fri'],
        offDay: this.offDayStatus['fri'],
      },
      {
        day: this.daysWeek[5],
        shiftStartTime: this.dayData.sat.startTime || null,
        shiftEndTime: this.dayData.sat.endTime || null,
        totalWorkingHour: this.dayData.sat.totalWorkingHours || null,
        WFH: this.toggleValues['sat'],
        offDay: this.offDayStatus['sat'],
      },
      {
        day: this.daysWeek[6],
        shiftStartTime: this.dayData.sun.startTime || null,
        shiftEndTime: this.dayData.sun.endTime || null,
        totalWorkingHour: this.dayData.sun.totalWorkingHours || null,
        WFH: this.toggleValues['sun'],
        offDay: this.offDayStatus['sun'],
      },
    ];

    this.shifttimedata = shiftDetails;

    // team evaluation
    const evaluationobj = {
      evaluation: f.value.evaluation ?? false,
      data: {
        type:
          f.value.all_team_evaluation === 'all_RadioBtn_team_evaluation'
            ? 'all'
            : f.value.all_team_evaluation === 'team_RadioBtn_team_evaluation'
              ? 'team'
              : null,
        values: {
          view: f.value.team_evaluation_viewList ?? false,
          add: f.value.team_evaluation_addNew ?? false,
          update: f.value.team_evaluation_update ?? false,
          sendmail: f.value.team_evaluation_sendEmail ?? false,
        },
      },
    };
    // change here muneeb true and team
    // team management
    const managementobj = {
      team_management: f.value.team_management ?? false,
      data: {
        type:
          f.value.all_team_management === 'all_radioBtn_team_management'
            ? 'all'
            : f.value.all_team_management === 'radio_btn_team_management'
              ? 'team'
              : null,
        values: {
          view: f.value.viewPayRoll_chkbox_team_management ?? false,
          update: f.value.updateCheckIn_chkbox_team_management ?? false,
          add: f.value.addNewUser_chkbox_team_management ?? false,
          create: f.value.createPayRoll_chkbox_team_management ?? false,
          delete: f.value.deleteUser_chkbox_team_management ?? false,
          monthly_salary: f.value.montlySalary_chkbox_team_management ?? false,
          updateUser: f.value.updateUser_chkbox_team_management ?? false,
          loanView: f.value.loanView_chkbox_team_management ?? false,
          loanAccept: f.value.loanAccept_chkbox_team_management ?? false,
          loanReject: f.value.loanReject_chkbox_team_management ?? false,
        },
      },
    };

    const managementobj1 = {
      team_management: true,
      data: {
        type: 'team',
        values: {
          view: false,
          update: false,
          add: false,
          create: false,
          delete: false,
          monthly_salary: false,
          updateUser: false,
          loanView: false,
          loanAccept: false,
          loanReject: false,
        },
      },
    };

    // team reasign
    const reasignobj = {
      resign: f.value.resign ?? false,
      data: {
        type:
          f.value.team_resign == 'all_radioBtn_team_resign'
            ? 'all'
            : f.value.team_resign === 'team_radioBtn_team_resign'
              ? 'team'
              : null,
        values: {
          view: f.value.viewList_chekboc_team_resign ?? false,
          accept: f.value.acceptResign_chekboc_team_resign ?? false,
          reject: f.value.rejectResign_chekboc_team_resign ?? false,
        },
      },
    };

    // holidays

    const holidayobj = {
      holidays: f.value.holidays ?? false,
      data: {
        type:
          f.value.team_holidays == 'all_radioBtn_team_holidays'
            ? 'all'
            : f.value.team_holidays === 'team_radioBtn_team_holidays'
              ? 'team'
              : null,
        values: {
          view: f.value.viewList_Chkbox_team_holidays ?? false,
          add: f.value.addNew_Chkbox_team_holidays ?? false,
          update: f.value.update_Chkbox_team_holidays ?? false,
          delete: f.value.delete_Chkbox_team_holidays ?? false,
        },
      },
    };

    // upload media object
    const uploadobj = {
      upload_media: f.value.upload_media ?? false,
      data: {
        type:
          f.value.team_upload_media == 'all_radioBtn_upload_media'
            ? 'all'
            : f.value.team_upload_media === 'team_radioBtn_upload_media'
              ? 'team'
              : null,
        values: {
          view: f.value.viewList_chekBox_upload_media ?? false,
          accept: f.value.uploadMedia_chekBox_upload_media ?? false,
          reject: f.value.deleteMedia_chekBox_upload_media ?? false,
        },
      },
    };
    // leave object
    const leaveobj = {
      leave_management: f.value.leave_management ?? false,
      data: {
        type:
          f.value.radio_leave_management == 'all_radioBtn_leave_management'
            ? 'all'
            : f.value.radio_leave_management ===
              'team_radioBtn_leave_management'
              ? 'team'
              : null,
        values: {
          view_leave:
            f.value.viewListAllLeaves_chekBox_leave_management ?? false,
          accept: f.value.acceptLeaves_chekBox_leave_management ?? false,
          reject: f.value.rejectLeaves_chekBox_leave_management ?? false,
          update: f.value.updateLeaves_chekBox_leave_management ?? false,
        },
      },
    };

    // attendance object
    const jsonObject = {
      attentance_management: f.value.attendace_management ?? false,
      data: {
        type:
          f.value.radio_team_attendance == 'attendace_managementEnable_all'
            ? 'all'
            : f.value.radio_team_attendance ===
              'attendace_managementEnable_team'
              ? 'team'
              : null,
        values: {
          view_attedance:
            f.value.viewAttendance_chkBox_attentance_management ?? false,
          sheet: f.value.sheet_chkBox_attentance_management ?? false,
          report: f.value.report_chkBox_attentance_management ?? false,
          edit: f.value.edit_chkBox_attentance_management ?? false,
          delete: f.value.delete_chkBox_attentance_management ?? false,
        },
      },
    };

    const eventobj = {
      event_managment: f.value.event_managment ?? false,
      data: {
        type:
          f.value.radio_team_event == 'event_managementEnable_all'
            ? 'all'
            : f.value.radio_team_event === 'event_managementEnable_team'
              ? 'team'
              : null,
        values: {
          view: f.value.view_chkBox_event_management ?? false,
          add: f.value.add_chkBox_event_management ?? false,
          edit: f.value.edit_chkBox_event_management ?? false,
          delete: f.value.delete_chkBox_event_management ?? false,
        },
      },
    };

    const accountobj = {
      account_managment: f.value.account_managment ?? false,
      data: {
        type:
          f.value.radio_team_account == 'account_managementEnable_all'
            ? 'all'
            : f.value.radio_team_account === 'account_managementEnable_team'
              ? 'team'
              : null,
        values: {
          view: f.value.view_chkBox_account_management ?? false,
          admin: f.value.add_supperadmin_account_management ?? false,
          add: f.value.add_chkBox_account_management ?? false,
          edit: f.value.edit_chkBox_account_management ?? false,
          delete: f.value.delete_chkBox_account_management ?? false,
          export: f.value.export_chkBox_account_management ?? false,
        },
      },
    };
    const farm_values = f.value;
    const isPortalCheckIn = farm_values.is_portal_checkin;
    const isPortalCheckIn_value = farm_values.portalCheckInRadioGroup;
    let portalCheckIn = 'Normal';
    if (isPortalCheckIn) {
      if (isPortalCheckIn_value != false) {
        portalCheckIn = isPortalCheckIn_value;
      }
    }

    const isUserRoleSelected = farm_values.user_role1;
    let roleType = '';
    if (isUserRoleSelected) {
      roleType = 'Employee';
    } else if (farm_values.user_role_admin || farm_values.user_role_team_lead) {
      if (this.admin && !this.team_lead) {
        roleType = 'Admin';
      } else if (!this.admin && this.team_lead) {
        roleType = 'Team_Lead';
      } else if (this.admin && this.team_lead) {
        roleType = 'Admin_AND_Team_Lead';
      }
    }

    const combinedData = {
      role_type: roleType,
      team_evaluation: evaluationobj,
      team_managment: managementobj,
      resign_data: reasignobj,
      holdays_data: holidayobj,
      upload_data: uploadobj,
      leave_data: leaveobj,
      attendance_data: jsonObject,
      event_data: eventobj,
      account_data: accountobj,
    };


    // var device_id = []; // Initialize an empty array to store device data

    // Inside your form submission or wherever you're adding device data
    // device_id.push({
    //   "device_name": f.value.device_name,
    //   "device_id": f.value.device_id
    // },
    // {
    //   "device_name": f.value.device_name,
    //   "device_id": f.value.device_id
    // },{
    //   "device_name": f.value.device_name,
    //   "device_id": f.value.device_id
    // });

    if (roleType === 'Team_Lead') {
      combinedData.team_managment = managementobj1;
    } else {
      combinedData.team_managment = managementobj;
    }
    // json nested objects printed
    this.objectDataJson = combinedData;
    this.showSpinner = true;
    const taxValue = f.value.tax ? f.value.tax : 0;
    if (this.uuid != null) {
      // update form
      this.addService
        .getUpdate(
          this.current_user_id,
          this.uuid,
          this.address.uuid,
          f.value.attendance_user_id,
          f.value.first_name,
          f.value.last_name,
          f.value.email,
          f.value.password,
          f.value.joining_date,
          f.value.dob,
          f.value.department,
          f.value.phone_number,
          f.value.cnic,
          f.value.gender,
          f.value.about,
          this.fileToUpload,
          f.value.user_image,
          f.value.organizationid,
          f.value.designation,
          f.value.employee_type,
          f.value.employee_status,
          f.value.employee_role,
          f.value.status,
          f.value.salary_type,
          f.value.salary,
          taxValue,
          f.value.ac_number,
          this.multiplepush,
          this.selectedCardName,
          JSON.stringify(this.devices),
          f.value.open_salary,
          f.value.address1,
          this.address_lat,
          this.address_lng,
          f.value.address2,
          f.value.city,
          f.value.state,
          f.value.postal_code,
          f.value.country,
          JSON.stringify(combinedData),
          portalCheckIn,
          f.value.sub_department,
          this.total_leaves,
          shiftDetails,
          this.user_shiftStarttime,
          this.user_shiftendtime,
          this.user_total_working_hours,
          f.value.role,
        )
        .then((value) => {

          this.showSpinner = false;
          if (value.success == true) {
            Swal.fire({
              iconHtml:
                ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
              title: 'User Created Successfully',
              showConfirmButton: false,
              timer: 1500,
            });
            this._location.back();
          } else {
            Swal.fire({
              iconHtml:
                ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
              title: value.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        });
    } else {
      // add form
      this.addService
        .getAdd(
          f.value.attendance_user_id,
          f.value.first_name,
          f.value.last_name,
          f.value.email,
          f.value.password,
          f.value.joining_date,
          f.value.dob,
          f.value.department,
          f.value.phone_number,
          f.value.cnic,
          f.value.gender,
          f.value.about,
          this.fileToUpload,
          f.value.user_image,
          f.value.organizationid,
          f.value.designation,
          f.value.employee_type,
          f.value.employee_status,
          f.value.employee_role,
          f.value.status,
          f.value.salary_type,
          f.value.salary,
          taxValue,
          f.value.ac_number,
          this.multiplepush,
          this.selectedCardName || 'DEMO_CARD',
          JSON.stringify(this.devices),
          f.value.open_salary,
          f.value.address1,
          this.address_lat,
          this.address_lng,
          f.value.address2,
          f.value.city,
          f.value.state,
          f.value.postal_code,
          f.value.country,
          JSON.stringify(combinedData),
          portalCheckIn,
          f.value.sub_department,
          this.total_leaves,
          shiftDetails,
          f.value.role,
        )
        .then((value) => {
          this.showSpinner = false;
          debugger
          if (value.success == true) {
            Swal.fire({
              iconHtml:
                ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
              title: 'User Created Successfully',
              showConfirmButton: false,
              timer: 1500,
            });
            this._location.back();
          } else {
            Swal.fire({
              iconHtml:
                ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
              title: value.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        });
    }
  }

  uploadProfileImage() {
    this.showSpinner = true;
    this.mediaService.uploadImage(this.formData).subscribe(
      (response) => {
        this.showSpinner = false;
        let l: any;
        l = response;
        this.imagePath = l.data.path;
      },
      (error) => {
        this.showSpinner = false;
      }
    );
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data;
      this.colormode = this.userInfo.color_mode;
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    });
  }

  getcard() {
    this.showSpinner = true;
    this.cards = [
      [
        { card_name: 'TEAM_LEAD_CARD', card_image: 'assets/user-cards/1.svg' },
        { card_name: 'MANAGER_CARD', card_image: 'assets/user-cards/2.svg' },
        { card_name: 'DEMO_CARD', card_image: 'assets/user-cards/3.svg' },
        { card_name: 'HR_CARD', card_image: 'assets/user-cards/4.svg' },
        { card_name: 'ADMIN_CARD', card_image: 'assets/user-cards/5.svg' },
        { card_name: 'FACUTY_CARD', card_image: 'assets/user-cards/6.svg' },
        {
          card_name: 'ADMIN_TEAM_LEAD_CARD',
          card_image: 'assets/user-cards/7.svg',
        },
        {
          card_name: 'FACULTY_MANAGER_CARD',
          card_image: 'assets/user-cards/8.svg',
        },
        { card_name: 'MANAGMENT_CARD', card_image: 'assets/user-cards/9.svg' },
        {
          card_name: 'HUMAN_RESOURCE_CARD',
          card_image: 'assets/user-cards/10.svg',
        },
        {
          card_name: 'SUPERADMIN_CARD',
          card_image: 'assets/user-cards/11.svg',
        },
        {
          card_name: 'OFFICE_FACUTY_CARD',
          card_image: 'assets/user-cards/12.svg',
        },
      ],
    ];
  }

  selectCard(cardName: string): void {
    this.selectedCardName = cardName;
  }
  toggleChangedMP(event: any): void {
    this.toggleValueMultiplePunch = event.target.checked;
    if (this.toggleValueMultiplePunch == true) {
      this.multiplepush = 'Yes';
    } else {
      this.multiplepush = 'No';
    }
  }
  toggleValues: Record<string, boolean> = {
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false,
    sun: false,
  };
  workFromHome: Record<string, string> = {
    mon: 'No',
    tue: 'No',
    wed: 'No',
    thu: 'No',
    fri: 'No',
    sat: 'No',
    sun: 'No',
  };

  toggleWHF(day: string, event: any): void {
    this.toggleValues[day] = event.target.checked;
    this.workFromHome[day] = this.toggleValues[day] ? 'Yes' : 'No';
  }
  daysOfWeek: string[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  copyRow(day: string): void {
    const startTime = (
      document.getElementById(`${day}_shift_start_time`) as HTMLInputElement
    ).value;
    const endTime = (
      document.getElementById(`${day}_shift_end_time`) as HTMLInputElement
    ).value;
    const workingHours = parseFloat(
      (
        document.getElementById(
          `${day}_total_working_hours`
        ) as HTMLInputElement
      ).value
    );
    const isWorkFromHome = this.toggleValues[day];
    const isHoliday = this.offDayStatus[day];

    // this.daysOfWeek.forEach((targetDay) => {
    //   if (targetDay !== day) {  // Skip the source day
    //     this.pasteRow(targetDay, { startTime, endTime, workingHours, isWorkFromHome, isHoliday });
    //   }
    // });
    this.pasteRow('tue', {
      startTime,
      endTime,
      workingHours,
      isWorkFromHome,
      isHoliday,
    });
    this.pasteRow('wed', {
      startTime,
      endTime,
      workingHours,
      isWorkFromHome,
      isHoliday,
    });
    this.pasteRow('thu', {
      startTime,
      endTime,
      workingHours,
      isWorkFromHome,
      isHoliday,
    });
    this.pasteRow('fri', {
      startTime,
      endTime,
      workingHours,
      isWorkFromHome,
      isHoliday,
    });
    this.pasteRow('sat', {
      startTime,
      endTime,
      workingHours,
      isWorkFromHome,
      isHoliday,
    });
    this.pasteRow('sun', {
      startTime,
      endTime,
      workingHours,
      isWorkFromHome,
      isHoliday,
    });
  }
  pasteRow(
    day: string,
    data: {
      startTime: string;
      endTime: string;
      workingHours: number;
      isWorkFromHome: boolean;
      isHoliday: boolean;
    }
  ): void {
    if (day == 'tue') {
      this.dayData.tue = {
        startTime: data.startTime,
        endTime: data.endTime,
        totalWorkingHours: data.workingHours,
      };
      this.toggleValues['tue'] = data.isWorkFromHome;
      this.offDayStatus['tue'] = data.isHoliday;
    }
    if (day == 'wed') {
      this.dayData.wed = {
        startTime: data.startTime,
        endTime: data.endTime,
        totalWorkingHours: data.workingHours,
      };
      this.toggleValues['wed'] = data.isWorkFromHome;
      this.offDayStatus['wed'] = data.isHoliday;
    }
    if (day == 'thu') {
      this.dayData.thu = {
        startTime: data.startTime,
        endTime: data.endTime,
        totalWorkingHours: data.workingHours,
      };
      this.toggleValues['thu'] = data.isWorkFromHome;
      this.offDayStatus['thu'] = data.isHoliday;
    }
    if (day == 'fri') {
      this.dayData.fri = {
        startTime: data.startTime,
        endTime: data.endTime,
        totalWorkingHours: data.workingHours,
      };
      this.toggleValues['fri'] = data.isWorkFromHome;
      this.offDayStatus['fri'] = data.isHoliday;
    }
    if (day == 'sat') {
      this.dayData.sat = {
        startTime: data.startTime,
        endTime: data.endTime,
        totalWorkingHours: data.workingHours,
      };
      this.toggleValues['sat'] = data.isWorkFromHome;
      this.offDayStatus['sat'] = data.isHoliday;
    }
    if (day == 'sun') {
      this.dayData.sun = {
        startTime: data.startTime,
        endTime: data.endTime,
        totalWorkingHours: data.workingHours,
      };
      this.toggleValues['sun'] = data.isWorkFromHome;
      this.offDayStatus['sun'] = data.isHoliday;
    }
  }
  // copyRow() {
  //   const firstDayValues = {
  //     startTime: this.monStartTime,
  //     endTime: this.monEndTime,
  //     totalWorkingHours: this.monTotalWorkingHours,
  //     toggleValue: this.toggleValues['mon'],
  //     offDayStatus: this.offDayStatus['mon']
  //   };

  //     this.tueStartTime=firstDayValues.startTime
  //     this.tueEndTime=firstDayValues.endTime;
  //     this.tueTotalWorkingHours= firstDayValues.totalWorkingHours;
  //     this.toggleValues['tue'] = firstDayValues.toggleValue;
  //     this.offDayStatus['tue'] = firstDayValues.offDayStatus;
  //     wedStartTime:any;
  //     wedEndTime:any;
  //     wedTotalWorkingHours:any;
  //     thuStartTime:any;
  //     thuEndTime:any;
  //     thuTotalWorkingHours:any;
  //     friStartTime:any;
  //     friEndTime:any;
  //     friTotalWorkingHours:any
  //     satStartTime:any;
  //     satEndTime:any;
  //     satTotalWorkingHours:any;
  //     sunStartTime:any;
  //     sunEndTime:any;
  //     sunTotalWorkingHours:any;
  //   }
  // }

  offDayStatus: Record<string, boolean> = {
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false,
    sun: false,
  };

  offDay(day: string): void {
    this.offDayStatus[day] = !this.offDayStatus[day];
    if (this.offDayStatus[day]) {
      this.dayData[day] = {
        startTime: null,
        endTime: null,
        totalWorkingHours: '0',
      };
    }
  }

  dayData: any = {
    mon: {
      startTime: '',
      endTime: '',
      totalWorkingHours: 0,
      workFromHome: false,
      offDay: false,
    },
    tue: {
      startTime: '',
      endTime: '',
      totalWorkingHours: 0,
      workFromHome: false,
      offDay: false,
    },
    wed: {
      startTime: '',
      endTime: '',
      totalWorkingHours: 0,
      workFromHome: false,
      offDay: false,
    },
    thu: {
      startTime: '',
      endTime: '',
      totalWorkingHours: 0,
      workFromHome: false,
      offDay: false,
    },
    fri: {
      startTime: '',
      endTime: '',
      totalWorkingHours: 0,
      workFromHome: false,
      offDay: false,
    },
    sat: {
      startTime: '',
      endTime: '',
      totalWorkingHours: 0,
      workFromHome: false,
      offDay: false,
    },
    sun: {
      startTime: '',
      endTime: '',
      totalWorkingHours: 0,
      workFromHome: false,
      offDay: false,
    },
  };
  getDayKey(day: string): string | undefined {
    return this.daysMap[day];
  }
  getDataFromApi(): void {
    this.usershittime.forEach((item: any) => {
      // const dayKey = this.getDayKey(item.day);
      const dayKey = item.day.toLowerCase().substring(0, 3); // 'mon', 'tue', etc.
      this.toggleValues[dayKey] = item.work_from_home === '1';
      this.offDayStatus[dayKey] = item.off_day === '1';
      if (dayKey) {
        this.dayData[dayKey] = {
          startTime: item.start_time,
          endTime: item.end_time,
          totalWorkingHours: item.total_working_hours,
        };
      }
    });
  }

  daysMap: Record<string, string> = {
    Monday: 'mon',
    Tuesday: 'tue',
    Wednesday: 'wed',
    Thursday: 'thu',
    Friday: 'fri',
    Saturday: 'sat',
    Sunday: 'sun',
  };

  // Method to handle Off Day toggle
  offDay1(day: string): void {
    this.dayData[day].offDay = !this.dayData[day].offDay;
  }


  saveDevice() {
    if (!this.devices) {
      this.devices = [];  // ✅ ensures it's defined before push
    }
    if (this.newDevice.device_name && this.newDevice.device_id) {
      this.devices.push({ ...this.newDevice, isEditing: false });
      this.newDevice = { device_name: '', device_id: '', isEditing: false };
      this.showForm = false;
    }
  }

  trackByIndex(index: number, item: any) {
    return index;
  }

  cancel() {
    this.newDevice = { device_name: '', device_id: '', isEditing: false };

    // hide form if table already has devices
    if (this.devices.length > 0) {
      this.showForm = false;
    }
  }

  addNewDevice() {
    this.showForm = true;
  }

  deleteDevice(index: number) {
    this.devices.splice(index, 1);
    if (this.devices.length === 0) {
      this.showForm = true; // show form if table is empty
    }
  }

  editDevice(index: number) {
    // here you can fill the form with selected device if needed
    this.newDevice = { ...this.devices[index], isEditing: true };
    this.showForm = true;
  }




    onAddress1Input() {
    const q = this.address1Value;
    if (q && q.length > 2) {
      this.fetchSuggestions(q);
    } else {
      this.filteredSuggestions = [];
    }
  }

  fetchSuggestions(data: string) {
    const query = data;
    this.dashboardService.getaddressSuggestion(query).then((value) => {
      this.filteredSuggestions = value;
    });
  }

  selectSuggestion(data: any) {
    this.address1Value = data.description;
    this.address_id = data.place_id;
    this.filteredSuggestions = [];
    this.dashboardService.getaddressLatlong(this.address_id).then((value) => {
      this.filteredSuggestions = value;
      this.address1Value = value.address1;
      this.address2Value = value.address2;
      this.city2 = value.city;
      this.state2 = value.state;
      this.postal_cide2 = value.postal_code;
      this.country2 = value.country;
      this.address_lat = value.geometry.location.lat;
      this.address_lng = value.geometry.location.lng;
    });
  }

  showValidationError(title: string) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    });

   Toast.fire({
      icon: 'error',
      title: title,
      customClass: {
        popup: 'colored-toast'
      }
    });
  }

  toggleDropdown(index: number) {
    if (this.dropdownOpenIndex === index) {
      this.dropdownOpenIndex = null; // close if already open
    } else {
      this.dropdownOpenIndex = index; // open clicked dropdown
    }
  }
}
